import { RecentFeaturedListing } from '@/slw/entities/dealer/sell-your-car';
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from '@/slw/shared/ui/carousel';
import { Skeleton } from '@/slw/shared/ui/skeleton';

import { RecentFeaturedCard } from './recent-featured-card.ui';

export function RecentFeaturedListings({
  dealerStatus,
  listings,
  isLoading,
}: {
  dealerStatus: boolean;
  listings: RecentFeaturedListing[];
  isLoading: boolean;
}) {
  if (isLoading) {
    return (
      <div>
        <h2 className='text-[2.5rem] font-bold mb-8 text-center'>Recent Featured Listings</h2>
        <div className='relative'>
          <Carousel opts={{ align: 'start', slidesToScroll: 1 }} className='w-full max-w-[1200px] mx-auto'>
            <CarouselContent>
              {[1, 2, 3].map((i) => (
                <CarouselItem key={i} className='basis-1/3 max-w-[400px]'>
                  <Skeleton className='h-[300px] w-full' />
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className='' />
            <CarouselNext className='' />
          </Carousel>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h2 className='text-[2.5rem] font-bold mb-8 text-center'>Recent Featured Listings</h2>
      <div className='relative 2xl:mx-0 px-12'>
        {listings.length ? (
          <Carousel
            opts={{ align: 'start', slidesToScroll: 1 }}
            className='w-full 2xl:max-w-[1360px] xl:max-w-[1280px] mx-auto'
          >
            <CarouselContent className=''>
              {listings.map((l) => (
                <CarouselItem key={l.id} className='lg:basis-1/3 2xl:pl-6 lg:pl-3  sm:basis-1/2 basis-full'>
                  <RecentFeaturedCard dealerStatus={dealerStatus} listing={l} />
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className='' />
            <CarouselNext className='' />
          </Carousel>
        ) : null}
      </div>
    </div>
  );
}
